import { render } from "./Acceptance.vue?vue&type=template&id=67013c3a&scoped=true"
import script from "./Acceptance.vue?vue&type=script&lang=js"
export * from "./Acceptance.vue?vue&type=script&lang=js"

import "./Acceptance.vue?vue&type=style&index=0&id=67013c3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67013c3a"]])

export default __exports__